import { CustomInput } from "reactstrap"
import cn from "classnames"

import { Text } from "ui-kit/components-branded/index"
import { HelpTooltip } from "components"
import { MyUserInfoLink } from "app/AppRouter/links"
import { ClientDiscountGroup } from "utils/interfaces"
import { INITIATOR } from "modules/discount/constants"

interface Props {
    id?: number
    title?: string
    description?: string
    selected?: boolean
    showSelect?: boolean
    view: "minimal" | "extended"
    selectedDiscount?: number
    onDiscountChange?: (discountId: number | undefined) => void
    group?: ClientDiscountGroup
    initiator?: INITIATOR
    hasPreviousSessions?: boolean
    can_be_applied?: boolean
}

export const DiscountListItem = (props: Props) => {
    const showDisabled = !props.can_be_applied && props?.initiator !== INITIATOR.CLIENT_ACCOUNT
    const titleClassName = showDisabled ? "discount__title__disabled" : "discount__title"
    const descriptionClassName = showDisabled
        ? "discount__description__disabled"
        : "discount__description"

    return (
        <div className="is-flex">
            {props.showSelect && (
                <CustomInput
                    id={`discount-${props.id ?? ""}`}
                    type="radio"
                    name="discount"
                    onChange={() => props.onDiscountChange?.(props.id)}
                    checked={props.id === props.selectedDiscount}
                    className="mr-1"
                    disabled={showDisabled}
                />
            )}
            <label
                htmlFor={`discount-${props.id ?? ""}`}
                className={cn("is-flex-grow-1 mb-0", {
                    "discount__list-pointer": props.showSelect,
                })}
            >
                <Text className="is-flex is-align-items-center">
                    <span className={cn("pr-2", titleClassName)}>{props.title}</span>
                    {props.view === "minimal" &&
                        props.group !== ClientDiscountGroup.abonements &&
                        props.description && (
                            <HelpTooltip
                                placement="top"
                                overlay={
                                    <Text isSecondary className={descriptionClassName}>
                                        {props.group === ClientDiscountGroup.referralProgram &&
                                            props.initiator === INITIATOR.CLIENT_ACCOUNT &&
                                            props.hasPreviousSessions && (
                                                <MyUserInfoLink className="is-block">
                                                    <div className="discount__recommend">
                                                        Порекомендуйте Alter еще раз
                                                    </div>
                                                </MyUserInfoLink>
                                            )}
                                        {props.description}
                                    </Text>
                                }
                            />
                        )}
                </Text>
                {props.view === "extended" && props.description && (
                    <div>
                        <Text isSecondary className={descriptionClassName}>
                            {props.group === ClientDiscountGroup.referralProgram &&
                                props.initiator === INITIATOR.CLIENT_ACCOUNT &&
                                props.hasPreviousSessions && (
                                    <MyUserInfoLink className="is-block">
                                        <div className="discount__recommend">
                                            Порекомендуйте Alter еще раз
                                        </div>
                                    </MyUserInfoLink>
                                )}
                            {props.description}
                        </Text>
                    </div>
                )}
            </label>
        </div>
    )
}
